import {withNamespaces} from "react-i18next";
import React, {useContext, useState} from "react";
import {AuthContext} from "./AuthContext";
import CancellationProcessComponent from "../../membership_cancellation/components/CancellationProcess.component";
import PtCancellationProcessComponent from "../../pt_cancellation/components/PtCancellationProcess.component";
import MoneyHelper from "../../../services/MoneyHelper";

const MembershipInformationComponent = withNamespaces()((props) => {
  const { t } = props;
  const { member, refreshMember } = useContext(AuthContext);
  const [showCancellationPopup, setShowCancellationPopup] = useState(false);
  const [showPtCancellationPopup, setShowPtCancellationPopup] = useState(false);
  // const [successMessage, setSuccessMessage] = useState(false);

  const showCancellation = () => {
    console.log('Show popup');
    if (member.mms_api === 'moso') {
      window.location.href = '/membership-cancellation';
    } else {
      setShowCancellationPopup(true);
    }
  };

  const closeCancellation = () => {
    setShowCancellationPopup(false);
  }

  const showPtCancellation = () => {
    setShowPtCancellationPopup(true);
  };

  const closePtCancellation = (cancelled) => {
    setShowPtCancellationPopup(false);
    if (cancelled) {
      refreshMember();
    }
  };

  // const unfreezeMembership = () => {
  //   CancellationService.unfreezeMembership().then(data => {
  //     console.log('Unfreeze');
  //   });
  // };
  // const freezeMembership = () => {
  //   CancellationService.freezeMembership().then(data => {
  //     console.log('freeze');
  //   });
  // };

  return !member ? null : (
    <React.Fragment>
      {showCancellationPopup && (
          <CancellationProcessComponent onEnd={closeCancellation}/>
      )}
      {showPtCancellationPopup && (
          <PtCancellationProcessComponent onEnd={closePtCancellation}/>
      )}
      <div className='membership-information-component'>
        <h3>{t('my_account_membership_information')}</h3>
        <div>
          <div className='membership-information-details'>
            <div>
              <p>{t('my_account_plan')}: </p>
              <p>{member.membership_type}</p>
            </div>
            <div>
              <p>{t('my_account_status')}: </p>
              <p>{member.membership_status}
                {member.canOpenCancellation() && (
                  <React.Fragment> | <a onClick={showCancellation}>{t('my_account_membership_cancellation')}</a></React.Fragment>
                )}
                {member.canOpenPtCancellation() && (
                  <React.Fragment> | <a onClick={showPtCancellation}>{t('my_account_pt_cancellation')}</a></React.Fragment>
                )}
              </p>
            </div>
            <div>
              <p>{t('my_account_start_date')}: </p>
              <p>{member.getFormattedStart()}</p>
            </div>
          </div>
          <div className='membership-actions'>
            {/*<button disabled={true} className='form-main-button white-with-border'>{props.t('my_account_membership_upgrade')}</button>*/}
            {/*{!member.is_freezed ?*/}
            {/*  (<button className='form-main-button white-with-border' onClick={freezeMembership}>{props.t('my_account_membership_freeze')}</button>) :*/}
            {/*  (<button className='form-main-button white-with-border' onClick={unfreezeMembership}>{props.t('my_account_membership_unfreeze')}</button>)*/}
            {/*}*/}
            {/*<button disabled={true} className='form-main-button white-with-border'>{props.t('my_account_membership_transfer_club')}</button>*/}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
});

MembershipInformationComponent.propTypes = {
};

const HelpComponent = withNamespaces()((props) => {
  const { t } = props;

  return (
    <div className='membership-information-component'>
      <h3>{t('my_account_help')}</h3>
      <p dangerouslySetInnerHTML={{__html: t('my_account_help_text')}} />
    </div>
  );
});

const PaymentInformationComponent = withNamespaces()((props) => {
  const { t } = props;
  const { member } = useContext(AuthContext);

  return !member ? null : (
    <div className='membership-information-component'>
      <h3>{t('my_account_payment_information')}</h3>
      <div>
        <div className='membership-information-details'>
          <div>
            <p>{t('my_account_payment_payment_type')}: </p>
            <p>{member.getPaymentInterval()}</p>
          </div>
          {member.plan_info && (
            <React.Fragment>
              <div>
                <p>{t('my_account_payment_monthly_dues')}: </p>
                <p>{MoneyHelper.toPrice(member.plan_info.nextDue)}</p>
              </div>
              <div>
                <p>{t('my_account_payment_renewal_date')}: </p>
                <p>{member.plan_info.getFormattedNextDueDate()}</p>
              </div>
              {member.plan_info.nextAnnualFee && member.plan_info.nextAnnualFee > 0 ? (
                <React.Fragment>
                  <div>
                    <p>{t('my_account_payment_annual_fee')}: </p>
                    <p>{MoneyHelper.toPrice(member.plan_info.nextAnnualFee)}</p>
                  </div>
                  <div>
                    <p>{t('my_account_payment_annual_fee_date')}: </p>
                    <p>{member.plan_info.getFormattedAnnualFeeDate()}</p>
                  </div>
                </React.Fragment>
              ) : null}
            </React.Fragment>
          )}
          <div>
            <p>{t('my_account_payment_payment_method')}: </p>
            <p>{t('my_account_payment_method_text', {last_four: member.default_card.last_four})}</p>
          </div>
        </div>
        {member.can_update_payment && (
          <div className='payment-actions'>
            <a href='/payment/edit' className='form-main-button white-with-border'>{props.t('my_account_membership_update')}</a>
          </div>
        )}
      </div>
    </div>
  );
});

PaymentInformationComponent.propTypes = {

}

const MyAccountComponent = (props) => {
  const { t } = props;

  return (
    <div className='my-account-component'>
      <h1>{t('my_account_header')}</h1>
      <MembershipInformationComponent />
      <PaymentInformationComponent />
      <HelpComponent />
    </div>
  );
};

export default withNamespaces()(MyAccountComponent);